<template>
    <div id='defectList' >
      <button id='junlie' defectid=1 @click="toAddDefect" class='icoBtn'></button>
      <button id='kuaizhuangliefeng' defectid=2 @click="toAddDefect" class='icoBtn'></button>
      <button id='zongxiangliefeng' defectid=3 @click="toAddDefect" class='icoBtn'></button>
      <button id='hengxiangliefeng' defectid=4 @click="toAddDefect" class='icoBtn'></button>
      <button id='kengcao' defectid=5 @click="toAddDefect" class='icoBtn'></button>
      <button id='songsan' defectid=6 @click="toAddDefect" class='icoBtn'></button>
      <button id='chenxian' defectid=7 @click="toAddDefect" class='icoBtn'></button>
      <button id='chezhe' defectid=8 @click="toAddDefect" class='icoBtn'></button>
      <button id='bolangyongbao' defectid=9 @click="toAddDefect" class='icoBtn'></button>
      <button id='fanyou' defectid=10 @click="toAddDefect" class='icoBtn'></button>
      <button id='kuaizhuangxiubu' defectid=11 @click="toAddDefect" class='icoBtn'></button>
      <button id='hengxiangliefengxiubu' defectid=12 @click="toAddDefect" class='icoBtn'></button>
      <button id='zongxiangliefengxiubu' defectid=13 @click="toAddDefect" class='icoBtn'></button>
      <button id='jijiang' defectid=14 @click="toAddDefect" class='icoBtn'></button>       
    </div>
</template>
<script>
  export default {
  name:'DefectListPanel', 
  data: function() {
    return {
      speed:80,
      showSelf:false,
      playIcon: '/static/imgs/player_play.png'
    }
  },
  methods: {
    toAddDefect : function(e){
      var defectId = $(e.currentTarget).attr("defectid");
       $(".icoBtn[defectid]").each(function(inex, item){
        $(item).removeAttr("selected");
      });
      $(e.currentTarget).attr("selected", "");
    },
    reset : function(e){
      
    } 
  }
}
</script>
<style lang='less'>
  #defectList{
    position:absolute;
    top:150px;
    right:140px;
    width:60px;
    height:500px;
    .icoBtn{
      position:absolute;
      background-size: cover;
      width:60px;
      height:60px;
      border:0px;
      background-color:transparent;
    }
    .icoBtn:hover{
      margin-top:-3px;
      cursor:pointer;
    }

     #junlie{
      background-image: url(/static/imgs/defect/junlie.png);
      left:0px;
      top:0px; 
    }
    
    #junlie[selected]{
      background-image: url(/static/imgs/defect/junlie_sel.png);
    }

    #kuaizhuangliefeng{
      background-image: url(/static/imgs/defect/kuaizhuangliefeng.png);
      left:90px;
      top:0px; 
    }
    
    #kuaizhuangliefeng[selected]{
      background-image: url(/static/imgs/defect/kuaizhuangliefeng_sel.png);
    }

    #zongxiangliefeng{
      background-image: url(/static/imgs/defect/zongxiangliefeng.png);
      left:0px;
      top:80px; 
    }
    
    #zongxiangliefeng[selected]{
      background-image: url(/static/imgs/defect/zongxiangliefeng_sel.png);
    }

    #hengxiangliefeng{
      background-image: url(/static/imgs/defect/hengxiangliefeng.png);
      left:90px;
      top:80px; 
    }
    
    #hengxiangliefeng[selected]{
      background-image: url(/static/imgs/defect/hengxiangliefeng_sel.png);
    }

    #kengcao{
      background-image: url(/static/imgs/defect/kengcao.png);
      left:0px;
      top:160px; 
    }
    
    #kengcao[selected]{
      background-image: url(/static/imgs/defect/kengcao_sel.png);
    }

    #songsan{
      background-image: url(/static/imgs/defect/songsan.png);
      left:90px;
      top:160px; 
    }
    
    #songsan[selected]{
      background-image: url(/static/imgs/defect/songsan_sel.png);
    }

    #chenxian{
      background-image: url(/static/imgs/defect/chenxian.png);
      left:0px;
      top:240px; 
    }
    
    #chenxian[selected]{
      background-image: url(/static/imgs/defect/chenxian_sel.png);
    }

    #chezhe{
      background-image: url(/static/imgs/defect/chezhe.png);
      left:90px;
      top:240px; 
    }
    
    #chezhe[selected]{
      background-image: url(/static/imgs/defect/chezhe_sel.png);
    }
    
    #bolangyongbao{
      background-image: url(/static/imgs/defect/bolangyongbao.png);
      left:0px;
      top:320px; 
    }
    
    #bolangyongbao[selected]{
      background-image: url(/static/imgs/defect/bolangyongbao_sel.png);
    }

    #fanyou{
      background-image: url(/static/imgs/defect/fanyou.png);
      left:90px;
      top:320px; 
    }
    
    #fanyou[selected]{
      background-image: url(/static/imgs/defect/fanyou_sel.png);
    }
    
    #kuaizhuangxiubu{
      background-image: url(/static/imgs/defect/kuaizhuangxiubu.png);
      left:0px;
      top:400px; 
    }
    
    #kuaizhuangxiubu[selected]{
      background-image: url(/static/imgs/defect/kuaizhuangxiubu_sel.png);
    }

    #hengxiangliefengxiubu{
      background-image: url(/static/imgs/defect/hengxiangliefengxiubu.png);
      left:90px;
      top:400px; 
    }
    
    #hengxiangliefengxiubu[selected]{
      background-image: url(/static/imgs/defect/hengxiangliefengxiubu_sel.png);
    }

    #zongxiangliefengxiubu{
      background-image: url(/static/imgs/defect/zongxiangliefengxiubu.png);
      left:0px;
      top:480px; 
    }
    
    #zongxiangliefengxiubu[selected]{
      background-image: url(/static/imgs/defect/zongxiangliefengxiubu_sel.png);
    }

    #jijiang{
      background-image: url(/static/imgs/defect/jijiang.png);
      left:90px;
      top:480px; 
    }
    
    #jijiang[selected]{
      background-image: url(/static/imgs/defect/jijiang_sel.png);
    }
    
    
  }

  
</style>



// WEBPACK FOOTER //
// src/plugins/components/Web3dModels/DefectListPanel.vue